<template>
  <div>
    <h1>Home</h1>
    <plaid-link></plaid-link>
    <el-table :data="accounts" class="top">
      <el-table-column prop="institution_name" label="Institution" width="150">
      </el-table-column>
      <el-table-column prop="name" label="Name">
      </el-table-column>
      <el-table-column prop="type" label="Type">
      </el-table-column>
      <el-table-column prop="subtype" label="Sub Type">
      </el-table-column>
      <el-table-column prop="current" label="Balance">
      </el-table-column>
    </el-table>
    <el-table :data="items" class="top">
      <el-table-column prop="item.institution_name" label="Institution" width="120">
      </el-table-column>
      <el-table-column prop="uid" label="UID">
      </el-table-column>
      <el-table-column prop="access_token" label="Access Token">
      </el-table-column>
      <el-table-column prop="item.webhook" label="Webhook">
      </el-table-column>
    </el-table>
    <el-row :gutter="20" class="top">
      <el-col :span="12">
        <el-card class="box-card" header="Plaid Transaction Count">
          <h1>{{plaidTransactionCount}}</h1>
        </el-card>
      </el-col>
      <el-col :span="12" class="cards">
        <el-card class="box-card" header="User Transaction Count">
          <h1>{{transactionCount}}</h1>
        </el-card>
      </el-col>
    </el-row>
    <el-table :data="transactions" class="top" :default-sort="{prop: 'date', order: 'descending'}">
      <el-table-column sortable prop="date" label="Date" width="150">
      </el-table-column>
      <el-table-column sortable prop="amount" label="Amount" width="150">
      </el-table-column>
      <el-table-column sortable prop="category" label="Category" width="150">
      </el-table-column>
      <el-table-column sortable label="Pending" width="150">
        <template scope="scope">
          {{ scope.row.pending ? 'true' : 'false' }}
        </template>
      </el-table-column>
      <el-table-column sortable prop="name" label="Name">
      </el-table-column>
    </el-table>
    <!--<pre>{{accounts}}</pre>-->
  </div>
</template>

<script>
import PlaidLink from './PlaidLink'
import { db, auth } from '../api.js'

export default {
  name: 'home',
  components: { PlaidLink },
  data() {
    return {
      accounts: [],
      items: [],
      transactions: [],
      pl_transactions: [],
    }
  },
  mounted() {
    const uid = auth.currentUser.uid
    this.$bindAsArray('accounts', db.ref(`accounts/${uid}`))
    this.$bindAsArray('items', db.ref(`items`))
    this.$bindAsArray('transactions', db.ref(`transactions/${uid}`))
    this.$bindAsArray('pl_transactions', db.ref(`pl_transactions/${uid}`))
  },
  computed: {
    transactionCount() {
      return this.transactions.length
    },
    plaidTransactionCount() {
      return this.pl_transactions.length
    }
  },
  methods: {
    getPending(isPending) {
      return isPending ? 'true' : 'false'
    }
  }

}
</script>

<style lang="stylus" scoped>
.top
  margin-top 30px
</style>



// WEBPACK FOOTER //
// Home.vue?8127d996